module.exports = __webpack_public_path__ + "img/113.55eddefd.jpg";